import { render, staticRenderFns } from "./DeliveriesView.vue?vue&type=template&id=685ce921"
import script from "./DeliveriesView.vue?vue&type=script&lang=js"
export * from "./DeliveriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports